import React, { Component } from "react";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { Trans } from "react-i18next";

am4core.useTheme(am4themes_animated);

class CompetencyQualification extends Component {
  state = {
    statsFetched: false,
    isManager: localStorage.getItem("roles").includes("Manager"),
    error: null,
    selectedDepartment: this.props.serviceType,
    selectedDepartmentQualification: this.props.Qualification,
    selectedDepartmentFutureQualification: this.props.FutureQualification,
  };

  chartDiv = React.createRef();
  chart = null;
  chartCreated = false;
  qualColor = "69a9f9";
  futureQualColor = "af46d1";

  componentDidMount = () => {
    this.competencyQualificationChart();
  };

  componentWillUnmount() {
    if (this.chart) {
      this.chart.dispose();
    }
  }

  competencyQualificationChart = () => {
    if (this.chart) {
      this.chart.dispose();
    }

    am4core.useTheme(am4themes_animated);
    // create chart
    this.chart = am4core.create(this.chartDiv.current, am4charts.GaugeChart);
    this.chart.innerRadius = am4core.percent(72);
    this.chart.paddingTop = am4core.percent(0);
    this.chart.paddingLeft = am4core.percent(0);
    this.chart.paddingRight = am4core.percent(0);
    this.chart.paddingBottom = am4core.percent(0);
    // let colorSet = new am4core.ColorSet();

    let axis2Chart2 = this.chart.xAxes.push(new am4charts.ValueAxis());
    axis2Chart2.min = 0;
    axis2Chart2.max = 100;
    axis2Chart2.strictMinMax = true;
    axis2Chart2.renderer.labels.template.disabled = true;
    axis2Chart2.renderer.ticks.template.disabled = true;
    axis2Chart2.renderer.grid.template.disabled = true;

    let axisChart2 = this.chart.xAxes.push(new am4charts.ValueAxis());
    axisChart2.min = 0;
    axisChart2.max = 100; //this.state.selectedDepartmentDealerTurnover;
    axisChart2.renderer.innerRadius = 10;
    axisChart2.strictMinMax = true;
    axisChart2.renderer.labels.template.disabled = true;
    axisChart2.renderer.ticks.template.disabled = true;
    axisChart2.renderer.grid.template.disabled = true;

    let chart2range0 = axisChart2.axisRanges.create();
    chart2range0.value = 0;
    chart2range0.endValue = this.state.selectedDepartmentQualification;
    chart2range0.axisFill.fillOpacity = 1;
    chart2range0.axisFill.fill = am4core.color("#af46d1");
    chart2range0.axisFill.radius = am4core.percent(100);
    chart2range0.axisFill.innerRadius = am4core.percent(60); // set it to >100 if you'd like to have some gap between fills
    chart2range0.grid.disabled = true;

    let chart2range1 = axisChart2.axisRanges.create();
    chart2range1.value = 0;
    chart2range1.endValue = 100;
    chart2range1.axisFill.fillOpacity = 1;
    chart2range1.axisFill.fill = am4core.color("#DADADA");
    chart2range1.axisFill.radius = am4core.percent(100);
    chart2range1.axisFill.innerRadius = am4core.percent(60); // set it to >100 if you'd like to have some gap between fills
    chart2range1.grid.disabled = true;

    let chart2range3 = axis2Chart2.axisRanges.create();
    chart2range3.value = 0;
    chart2range3.endValue = this.state.selectedDepartmentFutureQualification;
    chart2range3.axisFill.fillOpacity = 1;
    chart2range3.axisFill.fill = am4core.color("#69a9f9");
    chart2range3.axisFill.radius = am4core.percent(117);
    chart2range3.axisFill.innerRadius = am4core.percent(110); // set it to >100 if you'd like to have some gap between fills
    chart2range3.grid.disabled = true;

    let chart2range4 = axis2Chart2.axisRanges.create();
    chart2range4.value = 0;
    chart2range4.endValue = 100;
    chart2range4.axisFill.fillOpacity = 1;
    chart2range4.axisFill.fill = am4core.color("#DADADA");
    chart2range4.axisFill.radius = am4core.percent(117);
    chart2range4.axisFill.innerRadius = am4core.percent(110); // set it to >100 if you'd like to have some gap between fills
    chart2range4.grid.disabled = true;

    // let chart2range2 = axis2Chart2.axisRanges.create();
    // chart2range2.value = 0;
    // chart2range2.endValue = 100;
    // chart2range2.axisFill.fillOpacity = 1;
    // chart2range2.axisFill.fill = am4core.color("#69a9f9");
    // chart2range2.axisFill.radius = am4core.percent(117);
    // chart2range2.axisFill.innerRadius = am4core.percent(110); // set it to >100 if you'd like to have some gap between fills
    // chart2range2.grid.disabled = true;
    // chart2range2.zIndex = 1;

    // chart2range3.zIndex = 1;

    // chart2range4.zIndex = 0;

    let hand = this.chart.hands.push(new am4charts.ClockHand());
    hand.axis = axisChart2;
    hand.innerRadius = am4core.percent(10);
    hand.startWidth = 0;
    hand.pin.disabled = true;
    hand.value = 0;
    hand.opacity = 0;

    let hand2 = this.chart.hands.push(new am4charts.ClockHand());
    hand2.axis = axisChart2;
    hand2.innerRadius = am4core.percent(10);
    hand2.startWidth = 0;
    hand2.pin.disabled = true;
    hand2.value = 0;
    hand2.opacity = 0;

    // let hand3 = this.chart.hands.push(new am4charts.ClockHand());
    // hand3.axis = axisChart2;
    // hand3.innerRadius = am4core.percent(10);
    // hand3.startWidth = 0;
    // hand3.pin.disabled = true;
    // hand3.value = 0;
    // hand3.opacity = 0;

    hand.events.on("propertychanged", function (ev) {
      chart2range0.endValue = ev.target.value;
      chart2range1.value = ev.target.value;
      // console.log("hand " + ev.target.value);
    });
    // let drt = this.state.selectedDepartmentQualification; // h2
    // let dct = this.state.selectedDepartmentFutureQualification; // h3

    hand2.events.on("propertychanged", function (ev) {
      // chart2range4.value = drt > dct ? dct : 0;
      chart2range3.endValue = ev.target.value;
      chart2range4.value = ev.target.value;
    });
    // hand3.events.on("propertychanged", function (ev) {
    //   chart2range2.value = dct >= drt ? drt : 0;
    //   chart2range2.endValue = ev.target.value;
    // });
    new am4core.Animation(
      hand,
      {
        property: "value",
        to: this.state.selectedDepartmentQualification,
      },
      1500
    ).start();
    new am4core.Animation(
      hand2,
      {
        property: "value",
        to: this.state.selectedDepartmentFutureQualification,
      },
      1500
    ).start();
  };

  renderStats = () => {
    return (
      <div className="tamamlananEgitimAlani kbETO">
        <div id="kbETO_1" className="chartGraphic" ref={this.chartDiv}></div>
        <div className="satisSonrasiOrani">
          <div className="axis2range mb-2" style={{ color: "#69a9f9" }}>
            <div className="axisTitle">
              <Trans desc="Mevcut ETO">10172</Trans>
            </div>
            <sup>%</sup>
            {this.props.Qualification.toFixed(1)}
          </div>
          <div className="axis2range" style={{ color: "#af46d1" }}>
            <div className="axisTitle">
              <Trans desc="Gelecek ETO">10173</Trans>
            </div>
            <sup>%</sup>
            {this.props.FutureQualification.toFixed(1)}
          </div>
        </div>
      </div>
    );
  };

  render() {
    return (
      <div className="egitimTamamlanmaOrani yeterlilikGrafik">
        <div className="dashboardHeader">
          <div className="dashboardHeaderContent">
            <div className="egitimBaslik">{this.props.serviceType}</div>
          </div>
        </div>
        <hr />
        {this.renderStats()}
      </div>
    );
  }
}

export default CompetencyQualification;
